export default {
  'portal': 'https://portal.xunmengtu.com'
}